import {
    Box,
    Button,
    Divider,
    ListItemIcon,
    Paper,
    Tooltip,
    Typography,
} from '@material-ui/core';
import React, { useState } from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import PersonIcon from '@material-ui/icons/Person';
// import { Spinner } from '../../components/UI';
import { BackIcon, ShiftIcon } from '../../assets/svg';
import { HubSlotsDetails } from './HubSlotsDetails';
import Staff from '../staff';
import { HubSwitchKey } from './Settings';
import AddShiftTimingModal from '../../components/Modals/AddShiftTimingModal';
import { connect } from 'react-redux';
import { fetchSlotfilterList } from '../../store/actions/settingsActionCreator';
import AssignStaffToHubModal from '../../components/Modals/AssignStaffToHubModal';
import { HUB_TYPE_ENUM } from '../../utils/constants';
import UploadPayEarnModal from '../../components/Modals/UploadPayEarnModal';
import SlotListingPage from './slot-listing';
import moment from 'moment';
function HubSlotDetail({
    shiftList,
    selectedHub,
    permissions,
    setHubNShiftScreenSwitch,
    dispatchfetchSlotTimingList,
    ...props
}) {
    const [activeTab, changeActiveTab] = useState(0);
    const [staffModalOpen, setStaffModalOpen] = useState(false);
    const [shiftModalOpen, setShiftModalOpen] = useState(false);
    const [shiftListPayload, setshiftListPayload] = React.useState({
        pageNo: 1,
        pageSize: 10,
        searchText: '',
        dedicatedSlotGroupFilter: 'ALL', // ALL/PEAK/SHORTAGE
        startDate: moment().startOf('week').format('YYYY-MM-DD'),
        endDate: moment().endOf('week').format('YYYY-MM-DD'),
    });
    const [loading, toggleLoading] = useState(false);

    const fetchSlotList = async (filters = {}) => {
        await toggleLoading(true);
        const payload = {
            ...shiftListPayload,
            ...filters,
        };
        dispatchfetchSlotTimingList(
            payload,
            (resp) => {
                console.log(resp);
                toggleLoading(false);
            },
            (resp) => {
                console.log(resp);
                toggleLoading(false);
            },
        );
    };

    const _TAB = [
        {
            icon: (
                <ShiftIcon
                    style={{ width: 30, height: 30 }}
                    fill={activeTab === 0 ? '#fff' : '#65656d'}
                />
            ),
            label: 'Shift',
            content: (
                <SlotListingPage
                    renderHubFlow={true}
                    permissions={permissions}
                    hubInfo={selectedHub}
                    externalFiltered={{ hubIds: [selectedHub?.id] }}
                    loading={loading}
                    setHubNShiftScreenSwitch={setHubNShiftScreenSwitch}
                />
            ),
            disabled: !permissions?.read,
        },
    ];
    return <>{!_TAB[activeTab]?.disabled && _TAB[activeTab].content}</>;
}

const mapStateToProps = (state) => ({
    shiftList: state.settings?.shifts ?? [],
});

const mapDispatchToProps = (dispatch) => ({
    dispatchfetchSlotTimingList: (payload, onSuccess, onError) =>
        dispatch(fetchSlotfilterList(payload, onSuccess, onError)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HubSlotDetail);
